import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import {UserProfileForm} from '../../userProfile/components';
import {withRouter} from 'react-router';

import React, {Component, PropTypes} from 'react';

class CreateAccountProfilePage extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  render() {
    const {userId} = this.props.params;

    return (
      <div className="pre-dashboard-container">
        <div className="title">Your TEAMology Profile</div>
        <UserProfileForm userId={userId} />
        <div className="footer">
          <div>Copyright 2017 TEAMology, LLC. All Rights reserved.</div>
        </div>
      </div>
    );
  }
}

CreateAccountProfilePage.propTypes = {
  params: PropTypes.object.isRequired,
};

function mapStateToProps() {
  return {};
}

export default withRouter(connect(
  mapStateToProps, {}
)(CreateAccountProfilePage));



// WEBPACK FOOTER //
// ./app/features/authentication/components/CreateAccountProfilePage.js